import React from 'react';

const features = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#16a34a" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"/><path d="M12 7v5l3 3"/>
      </svg>
    ),
    title: '10 minute grocery now',
    desc: 'Get your order delivered to your doorstep at the earliest from ePayhub Store pickup stores near you.',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#16a34a" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M6 19m-2 0a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"/><path d="M17 19m-2 0a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"/><path d="M17 17h-11v-14h-2"/><path d="M6 5l14 1l-1 7h-13"/>
      </svg>
    ),
    title: 'Best Prices & Offers',
    desc: 'Cheaper prices than your local supermarket, great cashback offers to top it off. Get best prices & offers.',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#16a34a" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5"/><path d="M12 12l8 -4.5"/><path d="M12 12l0 9"/><path d="M12 12l-8 -4.5"/>
      </svg>
    ),
    title: 'Wide Assortment',
    desc: 'Choose from 5000+ products across food, personal care, household, bakery, veg and non-veg & other categories.',
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#16a34a" fill="none" strokeLinecap="round" strokeLinejoin="round">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4"/><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/>
      </svg>
    ),
    title: 'Easy Returns',
    desc: 'Not satisfied with a product? Return it at the doorstep & get a refund within hours. No questions asked policy.',
  },
];

export default function Features() {
  return (
    <section style={{ margin: '3rem 0' }}>
      <div className="container">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '2rem' }}>
          {features.map((f, i) => (
            <div key={i} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>{f.icon}</div>
              <div>
                <h3 style={{ fontWeight: 700, fontSize: '0.9375rem', color: '#111827', marginBottom: '6px' }}>{f.title}</h3>
                <p style={{ fontSize: '0.8125rem', color: '#6b7280', lineHeight: 1.6 }}>{f.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
